<template>
    <div class="input-editor">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive, getMarkAttrs }">
            <div class="input-editor-menubar">
                <button class="input-editor-menubar-button with-text" :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 1 })">
                    H1
                </button>
                <button class="input-editor-menubar-button with-image" :class="{ 'is-active': isActive.paragraph() }" @click="commands.paragraph">
                    <img src="@/assets/images/editor/paragraph.svg" alt="Paragraph"/>
                </button>
                <button class="input-editor-menubar-button with-text" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
                    B
                </button>
                <button class="input-editor-menubar-button with-image" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
                    <img src="@/assets/images/editor/ul.svg" alt="Unordered List"/>
                </button>
                <button class="input-editor-menubar-button with-image" :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list">
                    <img src="@/assets/images/editor/ol.svg" alt="Ordered List"/>
                </button>
                <button class="input-editor-menubar-button with-image" :class="{ 'is-active': isActive.link() }" @click="showLinkMenu(getMarkAttrs('link'))">
                    <img src="@/assets/images/editor/link.svg" alt="Link"/>
                </button>
                <button class="input-editor-menubar-button" @click="commands.undo">
                    Undo
                </button>
                <button class="input-editor-menubar-button" @click="commands.redo">
                    Redo
                </button>
            </div>
        </editor-menu-bar>
        <editor-menu-bubble :editor="editor" @hide="hideLinkMenu" v-slot="{ commands, menu }">
            <div
                :class="{ 'input-editor-menububble': true, 'is-active': menu.isActive }"
                :style="`left: ${ menu.left }px; bottom: ${ menu.bottom }px;`"
            >
                <form class="menububble-form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
                    <input class="menububble-input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
                    <button class="button button-blue menububble-button" type="submit">Save</button>
                    <button class="button button-gray menububble-button" @click="setLinkUrl(commands.link, null)" type="button">
                        Remove
                    </button>
                </form>
            </div>
        </editor-menu-bubble>
        <editor-content
            class="editor__content"
            :editor="editor"
        />
    </div>
</template>

<script>
import {
    Editor,
    EditorContent,
    EditorMenuBar,
    EditorMenuBubble,
} from 'tiptap';
import {
    Heading,
    OrderedList,
    BulletList,
    ListItem,
    Bold,
    Link,
    History,
    Placeholder,
} from 'tiptap-extensions';

export default {
    name: 'InputEditor',
    components: {
        EditorContent,
        EditorMenuBar,
        EditorMenuBubble,
    },
    props: {
        field: {
            type: String,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Write something …',
        },
    },
    data() {
        return {
            editor: null,
            linkUrl: null,
            linkMenuIsActive: false,
        };
    },
    watch: {
        element(newVal) {
            this.editor.setContent(newVal[this.field]);
        },
    },
    mounted() {
        this.editor = new Editor({
            extensions: [
                new Heading({ levels: [1] }),
                new BulletList(),
                new OrderedList(),
                new ListItem(),
                new Bold(),
                new Link(),
                new History(),
                new Placeholder({
                    emptyNodeClass: 'is-empty',
                    emptyNodeText: this.placeholder,
                    showOnlyWhenEditable: true,
                }),
            ],
            content: typeof this.element[this.field] !== 'undefined' ? this.element[this.field] : '',
            onUpdate: this.update,
        });
    },
    beforeDestroy() {
        this.editor.destroy();
    },
    methods: {
        showLinkMenu(attrs) {
            this.linkUrl = attrs.href;
            this.linkMenuIsActive = true;
            this.$nextTick(() => {
                this.$refs.linkInput.focus();
            });
        },
        hideLinkMenu() {
            this.linkUrl = null;
            this.linkMenuIsActive = false;
        },
        setLinkUrl(command, url) {
            command({ href: url });
            this.hideLinkMenu();
            this.editor.focus();
        },
        update(content) {
            this.element[this.field] = content.getHTML();
        },
    },
};
</script>
